import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreeViewEntity } from '../../models/tree-view-entity.model';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-drilldown',
  templateUrl: './drilldown.component.html',
  styleUrls: ['./drilldown.component.scss'],
})
export class DrillDownComponent implements OnInit {
  @Input() treeviewEntities: Array<TreeViewEntity>;
  @Input() defaultEntityId: number;
  @Input() disableParentSelection: boolean;
  @Input() placeholder: string = '';

  @Output() onEntitySelected: EventEmitter<TreeViewEntity> = new EventEmitter();

  currentEntity: TreeViewEntity;
  displayedValue: string = '';
  displayedList: Array<TreeViewEntity> = [];
  displayedRouteList: Array<TreeViewEntity> = [];

  constructor() {}

  ngOnInit() {
    this.resetComponent();
    this.treeviewEntities.forEach((e) => this.setDefaultValues(e));
  }

  selectEntity(template: BsDropdownDirective) {
    this.displayedValue = this.currentEntity.displayName
      ? this.currentEntity.displayName
      : this.currentEntity.name;
    if (template) {
      template.hide();
    }
    this.onEntitySelected.next(this.currentEntity);
  }

  changeCurrentEntity(item: TreeViewEntity, template: BsDropdownDirective) {
    this.currentEntity = item;
    this.displayedList = this.currentEntity.children;
    this.refreshDisplayedRouteList();
    if (template && (!item.children || !item.children.length)) {
      this.selectEntity(template);
    }
  }

  resetComponent() {
    this.currentEntity = null;
    this.displayedRouteList = [];
    this.displayedList = this.treeviewEntities;
  }

  onClearClicked() {
    this.resetComponent();
    this.displayedValue = '';
    this.onEntitySelected.next({});
  }

  private refreshDisplayedRouteList() {
    this.displayedRouteList = [];
    let currentModel: TreeViewEntity = this.currentEntity;
    this.displayedRouteList.unshift(currentModel);

    while (currentModel.parentId) {
      currentModel = currentModel.parent;
      this.displayedRouteList.unshift(currentModel);
    }
  }

  private setDefaultEntity(entity: TreeViewEntity) {
    if (entity.id !== this.defaultEntityId) {
      return;
    }
    this.changeCurrentEntity(entity, null);
    this.onEntitySelected.next(this.currentEntity);
    this.displayedValue = this.currentEntity.displayName;
  }

  private setDefaultValues(entity: TreeViewEntity) {
    this.setDefaultEntity(entity);
    entity.children.forEach((c) => {
      c.parent = entity;
      this.setDefaultEntity(c);
      if (c.children.length !== 0) {
        this.setDefaultValues(c);
      }
    });
  }
}
